var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"c-base-financial-summary-reload",attrs:{"href":"#"},on:{"click":_vm.reload}},[_c('i',{staticClass:"c-base-financial-summary-reload__icon icon"},[_vm._t("default")],2),_vm._v(" Recarregar ")])
}
var staticRenderFns = []

export { render, staticRenderFns }